module.exports = __webpack_public_path__ + "static/img/topwatch.356dcfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/topwatch.png
// module id = 5fpr
// module chunks = 1